var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiIntlstudentsguide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107286",
    "data-name": "Group 107286",
    transform: "translate(-457 -571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40442",
    "data-name": "Rectangle 40442",
    width: 32,
    height: 32,
    transform: "translate(457 571)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106169",
    "data-name": "Path 106169",
    d: "M9.6,5A15.737,15.737,0,0,0,2.94,6.34a.618.618,0,0,0-.38.58V8.84H1.92A1.886,1.886,0,0,0,0,10.76V27.4a1.886,1.886,0,0,0,1.92,1.92H14.58a1.9,1.9,0,0,0,2.84,0H30.08A1.886,1.886,0,0,0,32,27.4V10.76a1.886,1.886,0,0,0-1.92-1.92h-.64V6.92a.618.618,0,0,0-.38-.58A15.738,15.738,0,0,0,22.4,5,16.891,16.891,0,0,0,16,6.22,16.891,16.891,0,0,0,9.6,5Zm0,1.28a14.66,14.66,0,0,1,5.76,1.08v18.5A17.47,17.47,0,0,0,9.6,24.9a17.47,17.47,0,0,0-5.76.96V7.36A14.66,14.66,0,0,1,9.6,6.28Zm12.8,0a14.66,14.66,0,0,1,5.76,1.08v18.5a17.76,17.76,0,0,0-11.52,0V7.36A14.66,14.66,0,0,1,22.4,6.28Zm0,3.2a1.28,1.28,0,1,0,1.28,1.28A1.279,1.279,0,0,0,22.4,9.48Zm-2.04,4.48a.643.643,0,0,0,.12,1.28h.64v6.4h2.56V14.6a.6.6,0,0,0-.64-.64H20.36Z",
    transform: "translate(457 570)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiIntlstudentsguide);
export default __webpack_public_path__ + "static/media/visionai_intlstudentsguide.71ee1f7521ecf9f1bdd62a9442f6bfeb.svg";
export { ForwardRef as ReactComponent };